
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Lightbulb, TrendingUp, Zap } from 'lucide-react';

const AILeadEngineIntro = () => {
  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Intro Card */}
          <Card className="border-l-4 border-l-brand-blue shadow-lg mb-16">
            <CardContent className="p-8">
              <div className="flex items-start gap-6 mb-6">
                <div className="bg-brand-blue/10 p-3 rounded-full">
                  <Lightbulb className="h-6 w-6 text-brand-blue" />
                </div>
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    Van koud bellen naar warme connecties
                  </h2>
                  <div className="prose prose-lg text-gray-700 max-w-none space-y-6">
                    <p>
                      Bij Afsprakenmaker werken we continu aan manieren om onze klanten <strong>slimmer te helpen groeien</strong>. 
                      Onze nieuwste innovatie — de AI Lead Engine — brengt het beste van inbound en outbound samen.
                    </p>
                    <p>
                      <strong>Geen traditionele cold calls meer</strong>, maar warme outreach gebaseerd op realtime data en slimme automatisatie. 
                      En dit… met <span className="text-brand-red font-semibold">10x minder manuele opvolging</span> én <span className="text-brand-red font-semibold">5x meer output</span>.
                    </p>
                    <p className="text-brand-blue font-medium">
                      Momenteel beschikbaar als BETA voor geselecteerde klanten.
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Key Differentiators */}
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-gray-50 rounded-xl">
              <div className="bg-brand-blue/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <TrendingUp className="h-8 w-8 text-brand-blue" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-4">Slimmer prospecteren</h3>
              <p className="text-gray-600">
                Data-gedreven approach voor veel betere resultaten dan traditionele methodes
              </p>
            </div>

            <div className="text-center p-8 bg-gray-50 rounded-xl">
              <div className="bg-brand-red/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <Zap className="h-8 w-8 text-brand-red" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-4">Warme outreach</h3>
              <p className="text-gray-600">
                Elke contact is gebaseerd op echte interesse en gedrag van prospects
              </p>
            </div>

            <div className="text-center p-8 bg-gray-50 rounded-xl">
              <div className="bg-green-500/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <Lightbulb className="h-8 w-8 text-green-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-4">Maximale efficiency</h3>
              <p className="text-gray-600">
                Minder tijd investeren, meer kwalitatieve afspraken en betere conversie
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AILeadEngineIntro;
